var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLucideScanSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00781 7V5C3.00781 4.46957 3.21853 3.96086 3.5936 3.58579C3.96867 3.21071 4.47738 3 5.00781 3H7.00781M17.0078 3H19.0078C19.5382 3 20.047 3.21071 20.422 3.58579C20.7971 3.96086 21.0078 4.46957 21.0078 5V7M21.0078 17V19C21.0078 19.5304 20.7971 20.0391 20.422 20.4142C20.047 20.7893 19.5382 21 19.0078 21H17.0078M7.00781 21H5.00781C4.47738 21 3.96867 20.7893 3.5936 20.4142C3.21853 20.0391 3.00781 19.5304 3.00781 19V17",
    stroke: "#EF4444",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0078 15C13.6647 15 15.0078 13.6569 15.0078 12C15.0078 10.3431 13.6647 9 12.0078 9C10.351 9 9.00781 10.3431 9.00781 12C9.00781 13.6569 10.351 15 12.0078 15Z",
    stroke: "#EF4444",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0094 16.0016L14.1094 14.1016",
    stroke: "#EF4444",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLucideScanSearch);
export default __webpack_public_path__ + "static/media/lucide_scan-search.1847a9335739a6aea92431c58638617b.svg";
export { ForwardRef as ReactComponent };